<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Filtros</div>
          </div>
          <div class="card-body">
            <form action="">
              <div class="row">
                <div class="form-group col-md-2">
                  <label for="inputDateIn"> Data Inicial </label>
                  <input
                    type="date"
                    class="form-control"
                    id="inputDateIn"
                    v-model="filters.date_start"
                  />
                </div>
                <div class="form-group col-md-2">
                  <label for="inputDateOut"> Data Final </label>
                  <input
                    type="date"
                    class="form-control"
                    id="inputDateOut"
                    v-model="filters.date_end"
                  />
                </div>
                <div class="form-group col-md-3">
                  <label for="selectEmpr"> Selecione uma empresa </label>
                  <select
                    v-model="filters.company_id"
                    class="form-control"
                    id="selectEmpr"
                  >
                    <option
                      v-for="company in companies"
                      :value="company.id"
                      :key="company.id"
                    >
                      {{ company.company_name_fantasy }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-3">
                  <label for="selectFil"> Selecione uma filial </label>
                  <select
                    v-model="filters.branch_id"
                    class="form-control"
                    id="selectFil"
                  >
                    <option
                      v-for="branch in branches"
                      :value="branch.id"
                      :key="branch.id"
                    >
                      {{ branch.title }}
                    </option>
                  </select>
                </div>
                <div class="form-group col-md-2">
                  <a class="btn btn-main btn-block" @click="getCountHighlights"
                    >Filtrar</a
                  >
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <!-- Widgets -->
    <div class="row justify-content-md-center">
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Salas Cadastradas</div>
            <div class="card-value-info">{{ countHighlights.countRooms }}</div>
            <div class="card-percent up">13,5%</div>
            <i class="fas fa-door-open card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Estações Cadastradas</div>
            <div class="card-value-info">
              {{ countHighlights.countWorkstations }}
            </div>
            <div class="card-percent down">13,5%</div>
            <i class="fas fa-network-wired card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Usuários Cadastrados</div>
            <div class="card-value-info">{{ countHighlights.countUsers }}</div>
            <div class="card-percent up">13,5%</div>
            <i class="fas fa-users card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Salas Reservadas</div>
            <div class="card-value-info">
              {{ countHighlights.countRoomReservations }}
            </div>
            <div class="card-percent down">13,5%</div>
            <i class="fas fa-door-open card-icon"></i>
          </div>
        </div>
      </div>
      <div class="col-md">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Estações Reservadas</div>
            <div class="card-value-info">
              {{ countHighlights.countWorkstationReservations }}
            </div>
            <div class="card-percent up">13,5%</div>
            <i class="fas fa-network-wired card-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="row justify-content-md-center"
      v-if="$store.state.user.access_nivel == 3"
    >
      <div class="col-md-3">
        <div class="card">
          <div class="card-body position-relative overflow-hidden">
            <div class="card-small-info">Empresas Cadastradas</div>
            <div class="card-value-info">
              {{ countHighlights.countCompanies }}
            </div>
            <div class="card-percent up">13,5%</div>
            <i class="far fa-building card-icon"></i>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">Salas de reunião - Status de reserva</div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar
                  id="Chart1"
                  v-if="load"
                  class="centered"
                  :chart-data="dash.getRoomCharts"
                  :options="options1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Salas de reunião - Taxa de ocupação atual
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar
                  id="Chart1"
                  v-if="load"
                  class="centered"
                  :chart-data="dash.getRoomOccupationCharts"
                  :options="options2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Estação de Trabalho - Status de reserva
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar
                  id="Chart1"
                  v-if="load"
                  class="centered"
                  :chart-data="dash.getWorkstationCharts"
                  :options="options1"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card">
          <div class="card-header">
            <div class="card-title">
              Estação de Trabalho - Taxa de ocupação atual
            </div>
          </div>
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <ChartBar
                  id="Chart1"
                  v-if="load"
                  class="centered"
                  :chart-data="dash.getWorkstationOccupationCharts"
                  :options="options2"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBar from "@/components/Utils/ChartBar.js";
export default {
  data() {
    return {
      options1: {
        minBarLength: 0,
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        pieceLabel: {
          mode: "percentage",
          precision: 1,
        },
        scales: {
          xAxes: [
            {
              stacked: true,
            },
          ],
          yAxes: [
            {
              stacked: true,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      options2: {
        minBarLength: 0,
        responsive: true,
        maintainAspectRatio: false,
        height: 200,
        pieceLabel: {
          mode: "percentage",
          precision: 1,
        },
        scales: {
          xAxes: [
            {
              stacked: false,
            },
          ],
          yAxes: [
            {
              stacked: false,
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      countHighlights: {
        countRooms: 0,
        countWorkstations: 0,
        countUsers: 0,
        countRoomReservations: 0,
        countWorkstationReservations: 0,
        countCompanies: 0,
      },
      filters: {
        date_start: "",
        date_end: "",
        company_id: "",
        branch_id: "",
      },
      companies: [],
      branches: [],
      home: [],
      load: false,
      dash: {},
    };
  },
  computed: {},
  methods: {
    getCountHighlights: function () {
      const self = this;
      const api = self.$store.state.api + "countHighlights";

      this.load = false;

      let fd = {
        date_start: self.filters.date_start,
        date_end: self.filters.date_end,
        company: self.filters.company_id,
        branch: self.filters.branch_id,
      };

      self.$http
        .post(api, fd)
        .then((response) => {
          self.countHighlights.countRooms =
            response.data.getCountHighlights.countRooms;
          self.countHighlights.countWorkstations =
            response.data.getCountHighlights.countWorkstations;
          self.countHighlights.countUsers =
            response.data.getCountHighlights.countUsers;
          self.countHighlights.countRoomReservations =
            response.data.getCountHighlights.countRoomReservations;
          self.countHighlights.countWorkstationReservations =
            response.data.getCountHighlights.countWorkstationReservations;
          self.countHighlights.countCompanies =
            response.data.getCountHighlights.countCompanies;

          self.home = response.data;
          self.getRoomCharts();
          self.getRoomOccupationCharts();
          self.getWorkstationCharts();
          self.getWorkstationOccupationCharts();

          self.load = true;
        })
        .catch((error) => {
          self.$message(null, "Erro", "error");
        });
    },

    getRoomCharts: function () {
      const self = this;
      // Chart 01: Salas de reunião - Status de reserva

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";

        return result;
      }

      self.dash.getRoomCharts = {
        labels: self.home.getRoomChart.labels,
        datasets: [
          {
            label: "Qtde. Reservas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: self.home.getRoomChart.reserves,
          },
          {
            label: "Realizadas",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: self.home.getRoomChart.finishedReserves,
          },
          {
            label: "Não Realizadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: self.home.getRoomChart.canceledReserves,
          },
        ],
      };
    },

    getRoomOccupationCharts: function () {
      const self = this;
      // Chart 02: Salas de reunião - Taxa de ocupação atual

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getRoomOccupationCharts = {
        labels: self.home.getRoomOccupationChart.labels,
        datasets: [
          {
            label: "Disponíveis",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: [self.home.getRoomOccupationChart.availables],
          },
          {
            label: "Reservadas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: [self.home.getRoomOccupationChart.reserved],
          },
          {
            label: "Ocupadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: [self.home.getRoomOccupationChart.busy],
          },
        ],
      };
    },

    getWorkstationCharts: function () {
      const self = this;
      // Chart 03: Estação de Trabalho - Status de reserva

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getWorkstationCharts = {
        labels: self.home.getWorkstationChart.labels,
        datasets: [
          {
            label: "Qtde. Reservas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: self.home.getWorkstationChart.reserves,
          },
          {
            label: "Realizadas",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: self.home.getWorkstationChart.finishedReserves,
          },
          {
            label: "Não Realizadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: self.home.getWorkstationChart.canceledReserves,
          },
        ],
      };
    },

    getWorkstationOccupationCharts: function () {
      const self = this;
      // Chart 04: Estação de Trabalho - Taxa de ocupação atual

      const color1 = "#000000"; //Black
      const color2 = "#333333"; //Gray 01
      const color3 = "#666666"; //Gray 02
      const color4 = "#999999"; //Gray 03
      const color5 = "#cccccc"; //Gray 04
      const color6 = "#55efc4"; //Green
      const color7 = "#74b9ff"; //Blue
      const color8 = "#a29bfe"; //Purple
      const color9 = "#ffeaa7"; //Yellow
      const color10 = "#fab1a0"; //Orange
      const color11 = "#ff7675"; //Red

      function convertHex(hex, opacity) {
        hex = hex.replace("#", "");
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);

        const result =
          "rgba(" + r + "," + g + "," + b + "," + opacity / 100 + ")";
        return result;
      }

      self.dash.getWorkstationOccupationCharts = {
        labels: self.home.getWorkstationOccupationChart.labels,
        datasets: [
          {
            label: "Disponíveis",
            borderColor: convertHex(color6, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color6, 5),
            data: [self.home.getWorkstationOccupationChart.availables],
          },
          {
            label: "Reservadas",
            borderColor: convertHex(color8, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color8, 5),
            data: [self.home.getWorkstationOccupationChart.reserved],
          },
          {
            label: "Ocupadas",
            borderColor: convertHex(color11, 100),
            borderWidth: "2",
            backgroundColor: convertHex(color11, 5),
            data: [self.home.getWorkstationOccupationChart.busy],
          },
        ],
      };
    },

    getCompanies: function (id) {
      const self = this;
      const api = self.$store.state.api + "companies/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.companies = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },

    getBranches: function (id) {
      const self = this;
      const api = self.$store.state.api + "branches/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
  },
  components: {
    ChartBar,
  },
  mounted: function () {
    const self = this;
    self.getCountHighlights();
    self.getCompanies();
    self.getBranches();
  },
};
</script>

<style>
form {
  margin-block-end: unset;
}
.btn-reserve:hover,
.btn-reserve[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important ;
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue